import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { reject } from 'lodash/collection';

import { NSPS_STUDY } from '../../../../../../../services/i18n/namespaces';

export default function RadioSelect({ group, selectedTypeIds, setSelectedTypeIds }) {
  const { t } = useTranslation(NSPS_STUDY, { keyPrefix: 'studyType.types' });
  const { typeParent, types } = group;
  const value = useMemo(
    function() {
      return (
        types.find(function({ id }) {
          return selectedTypeIds.includes(id);
        })?.id || null
      );
    },
    [selectedTypeIds, types]
  );
  return (
    <RadioGroup
      name={typeParent + '_LABEL_ID'}
      value={value}
      onChange={function({ target }) {
        const id = target.value ? +target.value : null;
        setSelectedTypeIds(function(prevIds) {
          const sameValue = value === id;
          if (!sameValue && value) {
            return [...reject(prevIds, pId => pId === value), id].sort();
          }
          return [...prevIds, id].sort();
        });
      }}
    >
      {types?.map(({ id, type }) => {
        return (
          <FormControlLabel
            key={id}
            value={id}
            control={
              <Radio
                onClick={function(e) {
                  if (+e.target.value === value) {
                    e.preventDefault();
                    setSelectedTypeIds(function(prevIds) {
                      return reject(prevIds, pId => pId === value);
                    });
                  }
                }}
              />
            }
            label={t(type)}
            sx={{ m: 0 }}
          />
        );
      })}
    </RadioGroup>
  );
}
